// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"bb33b5e1","424":"4c22070e","620":"079b8921","674":"d94aaeb5","731":"edceee12","796":"89dbd76d"}[chunkId] + ".chunk.js";
};